import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useIsBusinessHourSectionEnabled } from '@bingads-webui-campaign-react/smart-page-context';
import { withErrorView } from '@bingads-webui-campaign-react/smart-page-error-boundary';

import { SmartBusinessHoursConnector } from './smart-hours-connector';

const getStyles = components => ({
  container: {
    ...components.section,
    marginLeft: '13%',
    marginRight: '13%',
  },
  title: {
    ...components.sectionTitle,
  },
  businessHoursContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
});

export const UnStyledSmartBusinesHoursViewWrapper = ({
  classes,
  id,
}) => {
  const i18n = useContext(I18nContext);
  const isBusinessHourSectionEnabled = useIsBusinessHourSectionEnabled();

  if (!isBusinessHourSectionEnabled) {
    return null;
  }

  return (
    <div
      id={id}
      className={classes.container}
    >
      <h2 className={classNames(classes.title, 'component-title')}>
        {i18n.getString(_TL_('Business Hours'))}
      </h2>
      <div className={classes.businessHoursContainer}>
        <SmartBusinessHoursConnector id={id} hideTitle />
      </div>
    </div>
  );
};

UnStyledSmartBusinesHoursViewWrapper.propTypes = {
  classes: PropTypes.shape({
    title: PropTypes.string.isRequired,
    container: PropTypes.string.isRequired,
    businessHoursContainer: PropTypes.string.isRequired,
  }).isRequired,
  id: PropTypes.string.isRequired,
};

export const SmartBusinessHoursViewWrapper = withErrorView(withDefaultStyles(
  UnStyledSmartBusinesHoursViewWrapper,
  getStyles
), 'componentMode');
